import type { FC } from 'react';
import type { CustomAvatarProps } from '@/types';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import clsx from 'clsx';
import React from 'react';

const sizeClasses = {
  xs: 'w-6 h-6',
  sm: 'w-10 h-10',
  md: 'w-16 h-16',
  lg: 'w-28 h-28',
  xl: 'w-36 h-36',
};

const CustomAvatar: FC<CustomAvatarProps> = ({
  src,
  alt,
  size = 'sm',
  fallback,
  children,
  className,
}) => {
  const defaultFallback = 'UN';
  return (
    <div className={`${className}`}>
      <Avatar
        className={clsx(
          'rounded-full cursor-pointer opacity-90 border-2 border-slate-500 dark:border-slate-200 relative',
          sizeClasses[size]
        )}
      >
        <AvatarImage src={src} alt={alt} />
        <AvatarFallback>{fallback || defaultFallback}</AvatarFallback>
      </Avatar>
      {children}
    </div>
  );
};

export default React.memo(CustomAvatar);
